import { render, staticRenderFns } from "./SelectFaceListModal.vue?vue&type=template&id=b1de19fa&scoped=true&"
import script from "./SelectFaceListModal.vue?vue&type=script&lang=js&"
export * from "./SelectFaceListModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectFaceListModal.vue?vue&type=style&index=0&id=b1de19fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1de19fa",
  null
  
)

export default component.exports